import { ReadingType } from 'infrastructure/enums';
import i18n from 'infrastructure/i18n';

export const getReadingTypeLabel = (
  readingType: ReadingType | string,
): string => {
  const map: Record<string, string> = {
    [ReadingType.SleepingMat]: i18n.t(`readingTypes.RestingPulse`),
    [ReadingType.SleepingMatDuration]: i18n.t(`readingTypes.RestingPulse`),
    [ReadingType.SleepingMatActivity]: i18n.t(`readingTypes.RestingPulse`),
  };

  if (map[readingType]) {
    return map[readingType];
  }

  return i18n.exists(`readingTypes.${readingType}`)
    ? i18n.t(`readingTypes.${readingType}` as any)
    : readingType;
};
